<template>
    <v-tab-item>
        <h5 class="page-text--lg mb-8 mb-lg-16">마이스펙 인증</h5>
        <p class="page-text--sm grey-6--text mb-8 mb-lg-12">금번 채용에서 해당 지원자의 역량이 인증되었다면 마이스펙 인증을 발급해주세요</p>
        <v-divider class="primary border-2 mb-12 mb-lg-24" />
        <application-certification v-model="form" outlined v-bind="{ mode }" />

        <div class="v-btn-group">
            <template v-if="mode == 'view'">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="mode = 'form'">
                    <span class="grey-6--text">{{ value?.isCertified ? "수정하기" : "발급하기" }}</span>
                </v-btn>
                <v-btn v-if="value?.isCertified" v-bind="{ loading }" color="secondary" class="min-w-140px min-w-lg-160px" @click="retract">
                    <span>발급취소하기</span>
                </v-btn>
            </template>
            <template v-if="mode == 'form'">
                <v-btn v-if="value?.isCertified" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="(mode = 'view') && sync()">
                    <span class="grey-6--text">수정취소</span>
                </v-btn>
                <v-btn v-if="mode == 'form'" v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="certify">
                    <span>{{ value?.isCertified ? "수정완료" : "발급하기" }}</span>
                </v-btn>
            </template>
        </div>

        <!-- <v-layout justify-center class="mt-20 mt-lg-40">
            <template v-if="mode == 'view'">
                <v-btn outlined @click="mode = 'form'"> {{ value?.isCertified ? "수정하기" : "발급하기" }} </v-btn>
                <v-btn v-if="value?.isCertified" dark color="red" v-bind="{ loading }" @click="retract">발급취소하기</v-btn>
            </template>
            <template v-if="mode == 'form'">
                <v-btn v-if="value?.isCertified" outlined @click="(mode = 'view') && sync()"> 수정취소 </v-btn>
                <v-btn v-if="mode == 'form'" dark color="primary" v-bind="{ loading }" @click="certify">{{ value?.isCertified ? "수정완료" : "발급하기" }}</v-btn>
            </template>
        </v-layout> -->
        
    </v-tab-item>
</template>

<script>
import api from "@/api";

import { initApplication } from "@/assets/variables";
import applicationCertification from "./application-certification.vue";

export default {
    components: { applicationCertification },
    props: {
        value: { type: Object, default: initApplication }, // application
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        form: initApplication(),

        mode: "view",
        loading: false,
    }),
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
    },
    methods: {
        init() {
            this.sync();
            this.mode = this.form?.isCertified ? "view" : "form";
        },
        sync() {
            this.form = initApplication(this.value);
        },
        async certify() {
            if (this.loading) return;
            this.loading = true;

            try {
                let { _id, _recruitment, certification } = this.form || {};

                const { application } = await api.v1.company.recruitments.applications.putIsCertified({ _id, _recruitment, certification, isCertified: true, certifiedAt: Date.now() });

                this.$emit("input", application);
                alert("근무확인서 발급이 처리되었습니다");
            } finally {
                this.loading = false;
                this.mode = "view";
            }
        },
        async retract() {
            if (this.loading) return;
            this.loading = true;

            try {
                let { _id, _recruitment, certification } = this.form || {};

                const { application } = await api.v1.company.recruitments.applications.putIsCertified({ _id, _recruitment, certification, isCertified: false, certifiedAt: null });

                this.$emit("input", application);
                alert("근무확인서 발급이 취소되었습니다");
            } finally {
                this.loading = false;
                this.mode = "view";
            }
        },
    },
};
</script>
